import { useSelector } from "react-redux";

export default function useCloudinaryData() {
  const commonConfigState = useSelector((state) => state.commonConfig);
  const cloudinaryData = commonConfigState?.data?.cloudinary;
  const currentSeasonYear =
    process.env.REACT_APP_CLOUDINARY_CURRENT_SEASON_YEAR;

  const configData = cloudinaryData;
  const cloudinaryBase = configData?.cloudinaryBaseUrl ? configData?.cloudinaryBaseUrl : process.env.REACT_APP_CLOUDINARY_BASE_URL;
  const envVersion = configData?.cloudinaryEnvVersion
    ? configData?.cloudinaryEnvVersion
    : process.env.REACT_APP_CLOUDINARY_ENV_VERSION;

  return { cloudinaryBase, envVersion, currentSeasonYear, configData };
}
